<template>
  <div class="box" v-if="screensByIssue">
    <p class="title is-5">
      Select Metrics to Display  
      <b-tooltip
        label="Metrics are ordered based on coverage and relevance to the selected portfolios. Not all YourStake metrics are available for display. For example, if your portfolio contains no banks, the 'Loans to Fossil Fuel Companies' metric will not be available."
        multilined
      >
        <b-icon
          pack="fas"
          icon="info-circle"
          size="is-small is-x-small"
        />
      </b-tooltip>
      <div class="pointer bottomMargin">
        <b-tag class="is-primary slightOpaque" @click="$emit('onClickSaveMetrics')">Save Metrics as Value Set</b-tag>
      </div>
    </p>
    <div v-for="issue in Object.keys(screensByIssue)" :key="issue">
        <b-collapse
        class="card"
        animation="slide"
        v-bind:open="false">
        <div
          slot="trigger"
          slot-scope="props"
          class="card-header"
          role="button">
          <p class="card-header-title"
          :class="'has-text-' + issue.replace(' ', '-').toLowerCase()"
          >
            {{ issue }} &nbsp;&nbsp;<small>({{ screensByIssue[issue].filter((i) => i.active).length }}/{{ screensByIssue[issue].length }})</small>
          </p>
        </div>
        <div class="card-content">
          <div class="content">
            <div v-for="metric in screensByIssue[issue]" v-bind:key="metric.id">
              <div class="field">
                <b-checkbox size="is-small" v-model="metric.active">
                  {{ metric.name }}
                </b-checkbox>
                <b-tooltip
                  v-bind:label="metric.description"
                  multilined
                >
                  <b-icon
                    pack="fas"
                    icon="info-circle"
                    v-on:click.native="triggerDetailPane(metric)"
                  />
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
  import eventBus from '@frontend/shared/EventBus.js';

  export default {
    data() {
      return {}
    },
    props: {
      screens: Array,
      screensByIssue: {
        type: Object,
        default: function() { return {} },
      }
    },
    components: {},
    methods: {
      triggerDetailPane: function(metric) {
        eventBus.$emit('reveal-screen-detail-pane', metric);
      }
    },
    computed: {},
    created: function() {},
  }
</script>

<style lang="scss">

</style>
